import { ArrowForward } from '@mui/icons-material';
import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    Icon,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useState } from 'react';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    bgcolor: 'background.paper',
    overflowY: 'auto',
    boxShadow: 24,
    px: 4,
};

const styleModalHeader = {
    top: 0,
    textAlign: 'center',
    position: 'sticky',
    zIndex: 15,
    py: 2,
    /* borderBottom: 'solid #0B3E83 1px', */
    backgroundColor: '#ffffff',
};

const styleModalFooter = {
    bottom: 0,
    top: 0,
    position: 'sticky',
    mt: 24,
    pb: 3,
    backgroundColor: '#ffffff',
    zIndex: 15,
};

const ModalEvento = ({ title, start, handleClose, handleGuardar, event }) => {
    const [evento, setEvento] = useState(
        event || {
            title: title || null,
            start: start || null,
            end: dayjs(start).add(1, 'hour'),
            allDay: false,
        },
    );

    const handleStartChange = (value) => {
        setEvento({
            ...evento,
            start: dayjs(value),
            end: dayjs(value).add(1, 'hour'),
        });
    };

    const handleAllDayChange = (event) => {
        setEvento({ ...evento, allDay: event.target.checked });
    };

    return (
        <Box sx={style}>
            <form>
                <Box sx={styleModalHeader}>
                    <Typography
                        id="modal-modal-title"
                        variant="h5"
                        color="primary"
                    >
                        {!event ? 'Crear nuevo' : 'Editar'} evento
                    </Typography>
                </Box>
                <Grid container spacing={5} sx={{ mt: '2px' }}>
                    <Grid item xs={12} md={12}>
                        <TextField
                            required
                            fullWidth
                            id="titulo"
                            label="Título del evento"
                            placeholder="Agrega un título"
                            variant="outlined"
                            value={evento.title}
                            onChange={(event) =>
                                setEvento({
                                    ...evento,
                                    title: event.target.value,
                                })
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid
                            container
                            display={'flex'}
                            justifyContent={'start'}
                            alignItems={'center'}
                        >
                            <Grid item xs={4}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    adapterLocale="es"
                                >
                                    <DateTimePicker
                                        ampm
                                        label="Inicio"
                                        value={evento.start}
                                        onChange={handleStartChange}
                                        sx={{ width: '100%' }}
                                    ></DateTimePicker>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={1}>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'center'}
                                >
                                    <Icon>
                                        <ArrowForward />
                                    </Icon>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    adapterLocale="es"
                                >
                                    <DateTimePicker
                                        ampm
                                        label="Fin"
                                        sx={{ width: '100%' }}
                                        value={evento.end}
                                        disabled
                                        /* onChange={handleEndChange} */
                                    ></DateTimePicker>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={3} pl={2}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={evento.allDay}
                                            onChange={handleAllDayChange}
                                        />
                                    }
                                    label={'Todo el día'}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={5} sx={styleModalFooter}>
                    <Grid item xs={12} md={6}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={handleClose}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() =>
                                handleGuardar(
                                    {
                                        ...evento,
                                        start:
                                            dayjs(evento.start).toISOString() ||
                                            null,
                                        end: dayjs(evento.end).toISOString(),
                                    },
                                    event ? true : false,
                                )
                            }
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
};

export default ModalEvento;
